import React, { useEffect, useState } from "react"
import Form from "antd/lib/form"
import useStateIfMounted from "Shared/utils/hooks/useStateIfMounted"
import { useTranslation } from "react-i18next"
import { doFilterSelect } from "Shared/utils/helpers"
import { getDynamicCostCenterList, getDynamicVendorsList, createDynamicList, getDynamicCostCenter2List } from "Shared/utils/filter.utils"
import { FilterFormInterface } from "Components/filter/filterTypes"
import { getTableFilterObjectStore } from "Shared/hooks/table.hooks"
import { CostCenter, CostCenter2, Vendor, WorkflowFilter, WorkflowScopeEnum, WorkflowTriggerEnum } from "@finway-group/shared/lib/models"
import FormSelect from "Components/form/formSelect"
import { FormSelectOption } from "Components/form/form.types"
import { useCompany } from "Shared/hooks/company.hooks"

const WorkflowFilterForm: React.FC<FilterFormInterface> = ({ table, formInstance, options, onSubmit }) => {
    const { t } = useTranslation()

    const tableFilterObject = getTableFilterObjectStore<WorkflowFilter>(table)
    const [workflowFilter, setWorkflowFilter] = useStateIfMounted(tableFilterObject)
    const [triggerType, setTriggerType] = useState(workflowFilter.triggerType)
    const { showCostCentersIds } = useCompany()

    useEffect(() => {
        formInstance.resetFields()
        setWorkflowFilter(workflowFilter)
    }, [])

    useEffect(() => {
        tableFilterObject.triggerType = triggerType
    }, [triggerType])

    useEffect(() => {
        formInstance.validateFields()
    }, [workflowFilter])

    const scopeList: FormSelectOption[] = createDynamicList("label:workflow.scope", [WorkflowScopeEnum.INVOICE, WorkflowScopeEnum.PURCHASE, WorkflowScopeEnum.REIMBURSEMENT])

    const triggerList: FormSelectOption[] = createDynamicList("label:workflow.trigger", [
        WorkflowTriggerEnum.VENDOR,
        WorkflowTriggerEnum.COST_CENTER,
        WorkflowTriggerEnum.USER,
        WorkflowTriggerEnum.AMOUNT,
        WorkflowTriggerEnum.COST_CENTER_2,
    ])

    return (
        <>
            <Form id="workflowForm" form={formInstance} onFinish={onSubmit}>
                <FormSelect name="scope" header={t("input:workflow.scope.scope")} initialValue={workflowFilter.scope} options={scopeList} isCollapse isForm fallback />

                <FormSelect
                    name="triggerType"
                    header={t("input:workflow.trigger.trigger_type")}
                    initialValue={triggerType}
                    options={triggerList}
                    onChange={(value: any) => setTriggerType(value)}
                    isCollapse
                    fallback
                    isForm
                />

                {triggerType === WorkflowTriggerEnum.VENDOR ? (
                    <FormSelect
                        name="vendor"
                        keyCode="vendor"
                        header={t("input:filter_form.vendor")}
                        initialValue={workflowFilter.vendor ?? ""}
                        options={getDynamicVendorsList(options.vendors as Vendor[])}
                        fallback={String(t("input:filter_form.all"))}
                        isCollapse
                        showSearch
                        isForm
                    />
                ) : triggerType === WorkflowTriggerEnum.COST_CENTER ? (
                    <FormSelect
                        name="costCenter"
                        header={t("input:expense_filter.cost_center")}
                        initialValue={workflowFilter.costCenter}
                        options={getDynamicCostCenterList(options.costCenters as CostCenter[], showCostCentersIds)}
                        fallback={String(t("input:filter_form.all"))}
                        isCollapse
                        showSearch
                        isForm
                    />
                ) : triggerType === WorkflowTriggerEnum.USER ? (
                    <FormSelect
                        name="requestedBy"
                        header={t("input:expense_filter.requester")}
                        initialValue={workflowFilter.requestedBy}
                        options={options.employees ?? []}
                        fallback={String(t("input:filter_form.all"))}
                        displayImages
                        isCollapse
                        showSearch
                        isForm
                    />
                ) : triggerType === WorkflowTriggerEnum.COST_CENTER_2 ? (
                    <FormSelect
                        name="costCenter2"
                        header={t("input:expense_filter.cost_center_2")}
                        initialValue={workflowFilter.costCenter2}
                        options={getDynamicCostCenter2List(options.costCenters2 as CostCenter2[])}
                        fallback={String(t("input:filter_form.all"))}
                        isCollapse
                        showSearch
                        isForm
                    />
                ) : null}
            </Form>
        </>
    )
}

export default WorkflowFilterForm
